import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Demo from "./components/account/demo/Demo";
import LoginContainer from "./components/account/login-container/LoginContainer";
import "./index.scss";
import Example from './components/account/example/Example';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Example />} />
        <Route
          exact
          path="/account/login/:appName/:permissions/:apps/:urlOK/:urlKO/:logo/:userId/:signature/:timestamp"
          element={<LoginContainer />}
        />
        <Route exact path="/account/demo" element={<Demo />} />
        <Route exact path="/account/example" element={<Example />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
